// Menu drawer: opens the native <dialog> from the header's Menu control, closes on the Close button, Escape
// (native) or a click on the backdrop. Without JavaScript the Menu control is a plain link to the catalog.
(() => {
  const dialog = document.getElementById('pl-mega-menu');
  const opener = document.querySelector('[data-menu-open]');
  if (!dialog || !opener || typeof dialog.showModal !== 'function') return;

  const setExpanded = (expanded) => opener.setAttribute('aria-expanded', String(expanded));

  opener.addEventListener('click', (event) => {
    event.preventDefault();
    dialog.showModal();
    setExpanded(true);
  });
  // The opener is a link with role="button", so it owes Space the same as Enter (a link only answers Enter).
  opener.addEventListener('keydown', (event) => {
    if (event.key !== ' ') return;
    event.preventDefault();
    opener.click();
  });

  dialog.querySelector('[data-menu-close]')?.addEventListener('click', () => dialog.close());

  // A click that lands on the <dialog> itself, not its panel, is a click on the backdrop.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', () => {
    setExpanded(false);
    opener.focus();
  });
})();
